import { createIcon } from '@chakra-ui/icons';

export const EditSimple = createIcon({
  displayName: 'EditSimple',
  viewBox: '0 0 13 12',
  d: 'M1.31507 10.6849H2.23562L7.90685 5.0137L6.9863 4.09315L1.31507 9.76438V10.6849ZM10.7178 4.06027L7.92329 1.29863L8.84384 0.378082C9.09589 0.126027 9.40559 0 9.77293 0C10.1398 0 10.4493 0.126027 10.7014 0.378082L11.6219 1.29863C11.874 1.55068 12.0055 1.8549 12.0164 2.21129C12.0274 2.56723 11.9068 2.87123 11.6548 3.12329L10.7178 4.06027ZM9.76438 5.03014L2.79452 12H0V9.20548L6.96986 2.23562L9.76438 5.03014ZM7.44658 4.55342L6.9863 4.09315L7.90685 5.0137L7.44658 4.55342Z',
});
